import React from "react";
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { WarningAmberOutlined as WarningIcon } from "@mui/icons-material";

interface RelationshipTypeSelectProps {
  value: string;
  options: string[];
  onChange: (value: string) => void;
  label?: string;
  size?: "small" | "medium";
  required?: boolean;
  sx?: any;
  /** When set, shows a warning if `value` isn't in `options` (e.g. it no longer matches the client's entity type). */
  mismatchWarning?: string;
}

const RelationshipTypeSelect: React.FC<RelationshipTypeSelectProps> = ({
  value,
  options,
  onChange,
  label = "Relationship Type",
  size,
  required,
  sx,
  mismatchWarning,
}) => {
  const isMismatch = !!mismatchWarning && !!value && !options.includes(value);

  return (
    <FormControl fullWidth size={size} required={required}>
      <InputLabel>{label}</InputLabel>
      <Select value={value} label={label} sx={sx} onChange={(e) => onChange(e.target.value)}>
        {isMismatch && (
          <MenuItem value={value}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
              <WarningIcon sx={{ fontSize: 14, color: "warning.main" }} />
              {value}
            </Box>
          </MenuItem>
        )}
        {options.map((r) => (
          <MenuItem key={r} value={r}>{r}</MenuItem>
        ))}
      </Select>
      {isMismatch && (
        <Typography
          variant="caption"
          color="warning.main"
          sx={{ mt: 0.5, display: "flex", alignItems: "center", gap: 0.5 }}
        >
          <WarningIcon sx={{ fontSize: 12 }} />
          {mismatchWarning}
        </Typography>
      )}
    </FormControl>
  );
};

export default RelationshipTypeSelect;
